module.exports = __webpack_public_path__ + "static/img/qrCode1.28c53a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/qrCode1.png
// module id = xm7B
// module chunks = 46